import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const BRAND  = '#E8940A';
const BRAND2 = '#F5A623';
const DARK   = '#1A1207';

const LoginPage = () => {
  const [email,    setEmail]    = useState('');
  const [password, setPassword] = useState('');
  const [showPass, setShowPass] = useState(false);
  const [error,    setError]    = useState('');
  const [loading,  setLoading]  = useState(false);

  const { login } = useAuth();
  const navigate  = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    const result = await login(email, password);
    if (result.success) {
      navigate('/dashboard');
    } else {
      setError(result.error || 'Email və ya şifrə yanlışdır');
    }
    setLoading(false);
  };

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800;900&display=swap');
        * { box-sizing: border-box; margin: 0; padding: 0; }
        body { font-family: 'Inter', -apple-system, sans-serif; }

        @keyframes spin { to { transform: rotate(360deg); } }
        @keyframes fadeUp {
          from { opacity: 0; transform: translateY(20px); }
          to   { opacity: 1; transform: translateY(0); }
        }

        .login-page {
          display: flex;
          min-height: 100vh;
          background: #FFF9F0;
        }

        /* ── Left ── */
        .login-left {
          flex: 0 0 44%;
          background: linear-gradient(150deg, ${BRAND} 0%, ${BRAND2} 50%, #C97A00 100%);
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 60px 48px;
          position: relative;
          overflow: hidden;
        }
        .login-left::before {
          content: '';
          position: absolute;
          top: -80px; right: -80px;
          width: 280px; height: 280px;
          border-radius: 50%;
          background: rgba(255,255,255,0.08);
        }
        .login-left::after {
          content: '';
          position: absolute;
          bottom: -60px; left: -60px;
          width: 220px; height: 220px;
          border-radius: 50%;
          background: rgba(255,255,255,0.06);
        }
        .login-left-inner {
          position: relative;
          z-index: 1;
          color: #fff;
          max-width: 340px;
          animation: fadeUp 0.6s ease;
        }
        .login-logo {
          display: flex;
          align-items: center;
          gap: 12px;
          margin-bottom: 36px;
        }
        .login-logo-icon {
          width: 48px; height: 48px;
          border-radius: 14px;
          background: rgba(255,255,255,0.2);
          display: flex; align-items: center; justify-content: center;
          font-size: 24px;
          backdrop-filter: blur(6px);
          border: 1px solid rgba(255,255,255,0.25);
        }
        .login-logo-name {
          font-size: 26px;
          font-weight: 900;
          color: #fff;
          letter-spacing: -0.5px;
        }
        .login-left-title {
          font-size: 36px;
          font-weight: 900;
          line-height: 1.15;
          color: #fff;
          margin-bottom: 14px;
          letter-spacing: -0.5px;
        }
        .login-left-sub {
          font-size: 15px;
          color: rgba(255,255,255,0.78);
          line-height: 1.7;
          margin-bottom: 36px;
        }
        .login-features { display: flex; flex-direction: column; gap: 12px; }
        .login-feature {
          display: flex;
          align-items: center;
          gap: 14px;
          background: rgba(255,255,255,0.12);
          border-radius: 12px;
          padding: 13px 16px;
          border: 1px solid rgba(255,255,255,0.18);
          backdrop-filter: blur(6px);
        }
        .login-feature-icon { font-size: 20px; }
        .login-feature-text { font-size: 14px; font-weight: 600; color: #fff; }

        /* ── Right ── */
        .login-right {
          flex: 1;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 40px 24px;
        }
        .login-card {
          width: 100%;
          max-width: 420px;
          background: #fff;
          border-radius: 24px;
          padding: 44px 40px;
          box-shadow: 0 8px 48px rgba(232,148,10,0.10);
          border: 1px solid #FDE68A;
          animation: fadeUp 0.5s ease;
        }

        /* Mobile logo (hidden on desktop) */
        .login-mobile-logo {
          display: none;
          align-items: center;
          justify-content: center;
          gap: 10px;
          margin-bottom: 28px;
        }
        .login-mobile-logo-icon {
          width: 44px; height: 44px;
          border-radius: 13px;
          background: linear-gradient(135deg, ${BRAND}, ${BRAND2});
          display: flex; align-items: center; justify-content: center;
          font-size: 22px;
          box-shadow: 0 4px 14px rgba(232,148,10,0.35);
        }
        .login-mobile-logo-name {
          font-size: 24px;
          font-weight: 900;
          color: ${DARK};
          letter-spacing: -0.3px;
        }

        .login-title {
          font-size: 28px;
          font-weight: 900;
          color: #0F172A;
          margin-bottom: 6px;
          letter-spacing: -0.5px;
        }
        .login-subtitle {
          font-size: 14px;
          color: #64748B;
          margin-bottom: 32px;
        }

        .login-form { display: flex; flex-direction: column; gap: 18px; }

        .form-field { display: flex; flex-direction: column; gap: 7px; }
        .form-label-row {
          display: flex;
          justify-content: space-between;
          align-items: center;
        }
        .form-label {
          font-size: 13px;
          font-weight: 700;
          color: #374151;
        }
        .form-forgot {
          font-size: 12px;
          color: ${BRAND};
          text-decoration: none;
          font-weight: 600;
        }
        .form-forgot:hover { text-decoration: underline; }

        .form-input-wrap {
          display: flex;
          align-items: center;
          border: 1.5px solid #E2E8F0;
          border-radius: 12px;
          overflow: hidden;
          background: #FAFAFA;
          transition: border-color 0.2s, box-shadow 0.2s;
        }
        .form-input-wrap:focus-within {
          border-color: ${BRAND};
          box-shadow: 0 0 0 3px rgba(232,148,10,0.12);
          background: #fff;
        }
        .form-icon {
          padding: 0 12px;
          font-size: 16px;
          line-height: 48px;
          background: #F8FAFC;
          border-right: 1px solid #E2E8F0;
          user-select: none;
        }
        .form-input {
          flex: 1;
          border: none;
          outline: none;
          padding: 13px 14px;
          font-size: 14px;
          color: #0F172A;
          background: transparent;
          font-family: inherit;
        }
        .form-eye {
          background: none;
          border: none;
          cursor: pointer;
          padding: 0 13px;
          font-size: 16px;
          color: #94A3B8;
          line-height: 1;
        }

        .form-error {
          display: flex;
          align-items: center;
          gap: 8px;
          background: #FEF9E7;
          border: 1px solid #FDE68A;
          border-radius: 10px;
          padding: 10px 14px;
          font-size: 13px;
          color: #92400E;
          font-weight: 500;
        }

        .form-btn {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          background: linear-gradient(135deg, ${BRAND} 0%, ${BRAND2} 100%);
          color: #fff;
          border: none;
          border-radius: 12px;
          padding: 14px;
          font-size: 15px;
          font-weight: 700;
          cursor: pointer;
          transition: all 0.2s;
          box-shadow: 0 4px 18px rgba(232,148,10,0.40);
          font-family: inherit;
          margin-top: 4px;
        }
        .form-btn:hover:not(:disabled) {
          transform: translateY(-2px);
          box-shadow: 0 8px 24px rgba(232,148,10,0.50);
        }
        .form-btn:disabled { opacity: 0.72; cursor: not-allowed; }

        .btn-spinner {
          width: 16px; height: 16px;
          border: 2.5px solid rgba(255,255,255,0.35);
          border-top-color: #fff;
          border-radius: 50%;
          animation: spin 0.7s linear infinite;
        }

        .login-divider {
          display: flex;
          align-items: center;
          gap: 12px;
          margin: 22px 0;
        }
        .login-divider-line { flex: 1; height: 1px; background: #E2E8F0; }
        .login-divider-text { font-size: 12px; color: #94A3B8; font-weight: 500; }

        .login-links { display: flex; gap: 10px; margin-bottom: 22px; }
        .login-link-primary {
          flex: 1;
          text-align: center;
          padding: 11px;
          background: rgba(232,148,10,0.08);
          border: 1.5px solid rgba(232,148,10,0.25);
          border-radius: 12px;
          font-size: 13px;
          font-weight: 700;
          color: ${BRAND};
          text-decoration: none;
          transition: background 0.2s;
        }
        .login-link-primary:hover { background: rgba(232,148,10,0.14); }
        .login-link-ghost {
          flex: 1;
          text-align: center;
          padding: 11px;
          background: #F8FAFC;
          border: 1.5px solid #E2E8F0;
          border-radius: 12px;
          font-size: 13px;
          font-weight: 600;
          color: #64748B;
          text-decoration: none;
          transition: background 0.2s;
        }
        .login-link-ghost:hover { background: #F1F5F9; }

        .login-footer {
          text-align: center;
          font-size: 12px;
          color: #CBD5E1;
        }

        /* ── Mobile ── */
        @media (max-width: 768px) {
          .login-left  { display: none !important; }
          .login-right { padding: 24px 16px; background: linear-gradient(160deg, #FFF9F0 0%, #FFF3D6 100%); }
          .login-card  {
            padding: 32px 24px;
            box-shadow: 0 4px 24px rgba(232,148,10,0.12);
          }
          .login-mobile-logo { display: flex !important; }
          .login-title { font-size: 22px; text-align: center; }
          .login-subtitle { text-align: center; }
        }
      `}</style>

      <div className="login-page">
        {/* ── Left ── */}
        <div className="login-left">
          <div className="login-left-inner">
            <div className="login-logo">
              <div className="login-logo-icon">☕</div>
              <span className="login-logo-name">Cafegoo</span>
            </div>
            <h2 className="login-left-title">Biznesinizi<br />idarə edin</h2>
            <p className="login-left-sub">
              Rezervasiyalar, menyu, analitika —<br />hər şey bir paneldə.
            </p>
            <div className="login-features">
              {[
                { icon: '📊', text: 'Real-time analitika' },
                { icon: '🍽️', text: 'Rezervasiya idarəetməsi' },
                { icon: '📋', text: 'Menyu redaktoru' },
                { icon: '🔔', text: 'Anlık bildirişlər' },
              ].map((f, i) => (
                <div key={i} className="login-feature">
                  <span className="login-feature-icon">{f.icon}</span>
                  <span className="login-feature-text">{f.text}</span>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* ── Right ── */}
        <div className="login-right">
          <div className="login-card">

            {/* Mobile logo */}
            <div className="login-mobile-logo">
              <div className="login-mobile-logo-icon">☕</div>
              <span className="login-mobile-logo-name">Cafegoo</span>
            </div>

            <h1 className="login-title">Xoş gəldiniz</h1>
            <p className="login-subtitle">Business Panel-ə daxil olun</p>

            <form onSubmit={handleSubmit} className="login-form">
              <div className="form-field">
                <label className="form-label">Email ünvanı</label>
                <div className="form-input-wrap">
                  <span className="form-icon">✉️</span>
                  <input
                    className="form-input"
                    type="email"
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                    placeholder="email@biznesiniz.az"
                    required
                  />
                </div>
              </div>

              <div className="form-field">
                <div className="form-label-row">
                  <label className="form-label">Şifrə</label>
                  <Link to="/forgot-password" className="form-forgot">Şifrəni unutdunuz?</Link>
                </div>
                <div className="form-input-wrap">
                  <span className="form-icon">🔒</span>
                  <input
                    className="form-input"
                    type={showPass ? 'text' : 'password'}
                    value={password}
                    onChange={e => setPassword(e.target.value)}
                    placeholder="••••••••"
                    required
                  />
                  <button type="button" className="form-eye" onClick={() => setShowPass(v => !v)}>
                    {showPass ? '🙈' : '👁️'}
                  </button>
                </div>
              </div>

              {error && (
                <div className="form-error">
                  <span>⚠️</span> {error}
                </div>
              )}

              <button type="submit" className="form-btn" disabled={loading}>
                {loading && <span className="btn-spinner" />}
                {loading ? 'Giriş edilir...' : 'Daxil ol →'}
              </button>
            </form>

            <div className="login-divider">
              <div className="login-divider-line" />
              <span className="login-divider-text">və ya</span>
              <div className="login-divider-line" />
            </div>

            <div className="login-links">
              <a href="/register" className="login-link-primary">📝 Qeydiyyat</a>
              <a href="/application-status" className="login-link-ghost">🔍 Müraciət statusu</a>
            </div>

            <p className="login-footer">© 2025 Cafegoo. Bütün hüquqlar qorunur.</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default LoginPage;
